export const DisputeTypeData = [

    {
    id: 1,
    disputeCode: "DT-001",
    disputeName: "Transaction Failure",
    description:
      "Raised when a payment or transaction fails but the amount is deducted from the user's account.",
    createdBy: "System Admin",
    createdDate: "2023-06-15",
    status: "Active",
  },
  {
    id: 2,
    disputeCode: "DT-002",
    disputeName: "Unauthorized Transaction",
    description:
      "Disputes related to transactions made without the user's consent or knowledge.",
    createdBy: "Legal Department",
    createdDate: "2023-07-22",
    status: "Active",
  },
  {
    id: 3,
    disputeCode: "DT-003",
    disputeName: "Refund Not Received",
    description:
      "Raised when a customer has not received a refund after a canceled order or failed payment.",
    createdBy: "Customer Support",
    createdDate: "2023-08-10",
    status: "Active",
  },
  {
    id: 4,
    disputeCode: "DT-004",
    disputeName: "Duplicate Transaction",
    description:
      "Occurs when a transaction is processed more than once for the same amount.",
    createdBy: "Operations Team",
    createdDate: "2023-09-05",
    status: "Inactive",
  },
  {
    id: 5,
    disputeCode: "DT-005",
    disputeName: "Incorrect Amount Charged",
    description:
      "Raised when the customer is charged a different amount than expected or shown.",
    createdBy: "Audit Department",
    createdDate: "2023-10-01",
    status: "Active",
  },
  {
    id: 6,
    disputeCode: "DT-006",
    disputeName: "Service Not Delivered",
    description:
      "When the payment was successful but the promised service or product was not delivered.",
    createdBy: "Customer Relations",
    createdDate: "2023-11-11",
    status: "Active",
  },
  {
    id: 7,
    disputeCode: "DT-007",
    disputeName: "Fraudulent Activity",
    description:
      "Suspicious or fraudulent transaction activity identified by the system or reported by a user.",
    createdBy: "Fraud Investigation Unit",
    createdDate: "2023-12-02",
    status: "Active",
  },
  
]